import { Component } from '@angular/core';
import { FilterService } from '../../services/filters/filter.service';
import { Router } from '@angular/router';
import { state } from '@angular/animations';
import { StorageService } from '../../services/storage/storage.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})

export class HomeComponent {

  propertyList: any[] = [
    // {
    //   img:"../../assets/images/banner1.jpeg"
    // },
    // {
    //   img:"../../assets/images/banner2.jpeg"
    // },
    // {
    //   img:"../../assets/images/banner3.jpeg"
    // }
    {
      img:"../../assets/images/IMG_20250125_130146.png"
    }
  ];

  constructor(private filterService: FilterService,
    private router: Router,
    private storageService: StorageService) {

  }
  searchProperties(event: any) {
    this.filterService.updateFilterObject('');
    this.router.navigate(['properties-list', {data: this.storageService.encrypt(JSON.stringify(event))}]);
  }

}
